import React from 'react';

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import NotificationEditor from '../../components/NotificationEditor';



class Notifications extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      pending: true
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({pending: false})
    }, 1500)
  }

  render() {

    if(this.state.pending === true) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          Notifications
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={true}
        />
      </React.Fragment>  
    }

    return(
      <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          Notifications
        </Typography>
        <Divider className="divider-white" />

        <NotificationEditor />
      </React.Fragment>  
    )
  }

}

export default Notifications;